import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref, onBeforeMount, nextTick } from 'vue'
import CommissionDisbursement from '@/views/ViewsComponents/commissionModle/CommissionDisbursement.vue'
import CommissionManagement from '@/views/ViewsComponents/commissionModle/CommissionManagement.vue'
import CommissionBase from '@/views/ViewsComponents/commissionModle/CommissionBase.vue'
import CommissionRatio from '@/views/ViewsComponents/commissionModle/CommissionRatio.vue'
import CommissionType from '@/views/ViewsComponents/commissionModle/CommissionType.vue'
import CommissionUser from '@/views/ViewsComponents/commissionModle/CommissionUser.vue'
import store from '@/store/index'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeName = ref('first')
const baseEle = ref()
const isShowCommission = ref<boolean>(false)
onBeforeMount(() => {
  isShowCommission.value = Object.keys(store.getters.privileges).includes('commission_manage')
  
})

const switchTabHandle = (ids: number[]) =>{
  activeName.value = 'base'
  nextTick(() => {
    
    baseEle.value.searchHandle({ids})

  })
  
}

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, {
      type: "border-card",
      modelValue: activeName.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: "提成发放",
          name: "first"
        }, {
          default: _withCtx(() => [
            _createVNode(CommissionDisbursement)
          ]),
          _: 1
        }),
        (isShowCommission.value)
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "提成管理"
            }, {
              default: _withCtx(() => [
                _createVNode(CommissionManagement)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tab_pane, {
          label: "提成基础",
          name: "base"
        }, {
          default: _withCtx(() => [
            _createVNode(CommissionBase, {
              ref_key: "baseEle",
              ref: baseEle
            }, null, 512)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "提成率",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(CommissionRatio)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "提成项目",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(CommissionType)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "提成汇总",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(CommissionUser, { onSwitchOrder: switchTabHandle })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})